import { render, staticRenderFns } from "./ReportDesktopGroupReservedUsers.vue?vue&type=template&id=291f1ae9"
import script from "./ReportDesktopGroupReservedUsers.vue?vue&type=script&lang=js"
export * from "./ReportDesktopGroupReservedUsers.vue?vue&type=script&lang=js"
import style0 from "./ReportDesktopGroupReservedUsers.vue?vue&type=style&index=0&id=291f1ae9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports